<template>
  <div class="arrow-config__container">
    <label class="arrow-config__checkbox">
      <input
        type="checkbox"
        v-model="active"
        @change="changeValue"
        @keyup="changeValue"
      />
      <div class="arrow-config__checkbox--checkmark"></div>
      {{ $t("ct-arrow-active") }}
    </label>
    <div v-show="active">
      <div class="arrow-config__field">
        <div class="arrow-config__label">{{ $t("ct-arrow-size-width") }}</div>
        <input-range
          v-model="width"
          @change="changeValue"
          :min="min"
          :max="max"
        />
      </div>
      <div class="arrow-config__field">
        <div class="arrow-config__label">
          {{ $t("ct-arrow-size-width-mobile") }}
        </div>
        <input-range
          v-model="widthMobile"
          @change="changeValue"
          :min="min"
          :max="max"
        />
      </div>
      <div class="arrow-config__field">
        <div class="arrow-config__label">{{ $t("ct-arrow-size-height") }}</div>
        <input-range
          v-model="height"
          @change="changeValue"
          :min="min"
          :max="max"
        />
      </div>
      <div class="arrow-config__field">
        <div class="arrow-config__label">{{ $t("ct-arrow-color") }}</div>
        <color-picker-component ref="colorPicker" />
      </div>
    </div>
  </div>
</template>

<script>
import ColorPickerComponent from "./Abstract/ColorPicker";
import InputRange from "./Abstract/InputRange";

export default {
  name: "ArrowConfigComponent",
  components: { ColorPickerComponent, InputRange },
  data() {
    return {
      element: null,
      active: false,
      width: 33,
      widthMobile: 100,
      height: 50,
      valueColor: "#F0F0F0",
      labelDesc: "opa",
      callback: null,
      min: 0,
      max: 100,
    };
  },
  methods: {
    changeValue() {
      if (this.width > 100) {
        this.width = 100;
      }
      if (this.width < 0) {
        this.width = 0;
      }
      if (this.widthMobile > 100) {
        this.widthMobile = 100;
      }
      if (this.widthMobile < 0) {
        this.widthMobile = 0;
      }
      if (this.height > 500) {
        this.height = 500;
      }
      if (this.height < 0) {
        this.height = 0;
      }

      let obj = {
        arrowActive: this.active,
        arrowWidth: this.width,
        arrowWidthMobile: this.widthMobile,
        arrowHeight: this.height,
        arrowColor: this.valueColor,
      };

      this.callback(obj);
    },
    setValues(obj) {
      let vm = this;

      this.active = obj.defaultArrowActive;
      this.width = obj.defaultArrowWidth;
      this.widthMobile = obj.defaultArrowWidthMobile;
      this.height = obj.defaultArrowHeight;
      this.valueColor = obj.defaultArrowColor;

      this.element = obj.element;
      this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
      this.callback = obj.callback;

      let newObj = Object.assign({}, obj);
      newObj.defaultValue = this.valueColor;
      newObj.callback = (value) => {
        vm.valueColor = value;
        vm.changeValue();
      };
      this.$refs.colorPicker.setValues(newObj);
    },
  },
};
</script>

<style lang="sass" scoped>
.arrow-config__container
	display: flex
	flex-direction: column
	padding: 0 15px
	margin-bottom: 30px
	.arrow-config__checkbox
		display: flex
		align-items: center
		margin-bottom: 17px
		font: normal normal normal 11px/14px Muli
		letter-spacing: 0.33px
		color: #5A5959
		cursor: pointer
		.arrow-config__checkbox--checkmark
			display: flex
			align-items: center
			justify-content: center
			width: 20px
			height: 20px
			background-color: #EBEFF3
			border-radius: 3px
			margin-right: 10px
			transition: background-color 200ms
			&:hover
				background-color: darken(#EBEFF3, 5%)
		input[type="checkbox"]
			display: none
			&:checked ~ .arrow-config__checkbox--checkmark
				background-color: #0080FC
				&:hover
					background-color: darken(#0080FC, 5%)
				&:before
					content: "✔"
					color: #FFFFFF
					font-size: 14px
	.arrow-config__field
		display: flex
		flex-direction: column
		margin-bottom: 17px
		.arrow-config__label
			font: normal normal 600 13px/14px Muli
			color: #5A5959
			margin-bottom: 15px
</style>




// WEBPACK FOOTER //
// src/components/editor/resource_components/ArrowConfig.vue